import * as React from 'react';
import HelpOutline from '@material-ui/icons/HelpOutline';
import { DSIconButton } from '../Generic';
import { DSNotifier, DSTypography } from '../mui';
import { Translate } from '../Translate';

export function MultiImagePickerHelpPopper(): JSX.Element {
    return (
        <DSNotifier
            anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
            render={({ onClick }) => (
                <DSIconButton role="button" size="small" onClick={onClick}>
                    <HelpOutline />
                </DSIconButton>
            )}
            transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <div style={{ maxWidth: '400px', padding: '12px' }}>
                <DSTypography variant="h5">
                    <Translate keyId="BUILD.MULTI_IMAGE.MULTI_IMAGE_TEMPLATE" />
                </DSTypography>
                <DSTypography>
                    <Translate keyId="BUILD.MULTI_IMAGE.NOTIFIER_EXPLANATION" />
                </DSTypography>
            </div>
        </DSNotifier>
    );
}
MultiImagePickerHelpPopper.displayName = 'MultiImagePickerHelpPopper';
